const standardMarkersEnums = Object.freeze({
  CENTER_POINT: 'Center Point',
  CENTER_BOX: 'Center Box',
  COLD_POINT: 'Cold Point',
  HOT_POINT: 'Hot Point',
});

export default standardMarkersEnums;
